import { render } from "./SettingsView.vue?vue&type=template&id=c65331aa&scoped=true&ts=true"
import script from "./SettingsView.vue?vue&type=script&lang=ts"
export * from "./SettingsView.vue?vue&type=script&lang=ts"

import "./SettingsView.vue?vue&type=style&index=0&id=c65331aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65331aa"]])

export default __exports__